<template>
  <div class="fineprint">
    <CheckoutTermsAndConditions :as-bold="asBold" />
    <CheckoutPassageOfTitle />
    <p v-if="showCaliforniaWarning || passageOfTitleStatement">
      <strong>
        Warning:
      </strong>
      Many food and beverage cans have linings containing bisphenol A (BPA), a
      chemical known to the State of California to cause harm to the female
      reproductive system. Jar lids and bottle caps may also contain BPA. You
      can be exposed to BPA when you consume foods or beverages packaged in
      these containers. For more information go to
      <a href="http://www.P65Warnings.ca.gov" target="_blank"
        >www.P65Warnings.ca.gov</a
      >. For a list of products go to:
      <a href="http://www.prop65bpa.org" target="_blank">www.prop65bpa.org</a>.
    </p>
    <p v-if="showCaliforniaWarning || passageOfTitleStatement">
      <strong>Warning:</strong>
      Drinking distilled spirits, beer, coolers, wine and other alcoholic
      beverages may increase cancer risk, and, during pregnancy, can cause birth
      defects. For more information go to
      <a href="https://www.P65Warnings.ca.gov/alcohol" target="_blank"
        >www.P65Warnings.ca.gov/alcohol</a
      >.
    </p>
    <p>
      <strong>Please note:</strong>
      All sales are final. Your credit card will be charged at the time of
      purchase.
    </p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CheckoutPassageOfTitle from '~/components/Checkout/CheckoutPassageOfTitle.vue'
import CheckoutTermsAndConditions from '~/components/Checkout/CheckoutTermsAndConditions.vue'

export default {
  name: 'CheckoutTermsAndConditionsAndWarnings',
  components: { CheckoutPassageOfTitle, CheckoutTermsAndConditions },
  inheritAttrs: true,
  props: {
    asBold: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['checkoutState']),
    address() {
      if (this.checkoutState.shipping.selectedAddress) {
        return this.checkoutState.shipping.selectedAddress
      } else if (this.checkoutState.shipping.selectedPickupAddress) {
        return this.checkoutState.shipping.selectedPickupAddress
      } else {
        return null
      }
    },
    showCaliforniaWarning() {
      if (this.address) {
        return (
          this.address.state_name === 'California' ||
          this.address.state === 'California' ||
          this.address.state === 'CA'
        )
      } else {
        return false
      }
    },
    passageOfTitleStatement() {
      if (this.checkoutState.placeOrder) {
        return this.checkoutState.placeOrder.passageOfTitleStatement
      }
      return this.cart.passageOfTitleStatement
    },
  },
}
</script>

<style scoped></style>
